<template>
	<div v-if="arrayNoteSpese.length > 0" class="card mt-3">
		<div class="card-header bg-light">
			<div class="d-flex justify-content-between align-items-center cursor-pointer" @click="toggleCollapse()">
				<h6 class="mb-0">
					<i :class="collapsed ? 'ph-caret-right' : 'ph-caret-down'" class="me-2"></i>
					NOTE SPESE
				</h6>
				<span class="badge bg-primary">{{ totalImporto }}</span>
			</div>
		</div>

		<div v-if="!collapsed" class="card-body p-0">
			<div class="list-group list-group-flush">
				<div v-for="(utente, idx) in perUtente" :key="'utente-' + idx" class="list-group-item">
					<div class="cursor-pointer d-flex justify-content-between align-items-center" @click="toggleUtente(utente.FK_ID_UTENTE)">
						<div class="d-flex align-items-center">
							<i :class="utenteCollapsed[utente.FK_ID_UTENTE] !== false ? 'ph-caret-right' : 'ph-caret-down'" class="me-2"></i>
							<strong>{{ utente.nome }}</strong>
						</div>
						<span class="badge bg-info">{{ filters.formattaImporto(utente.totale) }}</span>
					</div>

					<div v-if="utenteCollapsed[utente.FK_ID_UTENTE] === false" class="ms-4 mt-2">
						<div v-for="nota in utente.note" :key="'nota-' + nota.ID_NOTA_SPESA" class="row mb-2 align-items-center">
							<div class="col-md-2">
								<small class="text-muted">{{ filters.formatDate(nota.DATA) }}</small>
							</div>
							<div class="col-md-4">
								<small>{{ nota.DESCRIZIONE }}</small>
							</div>
							<div class="col-md-2 text-end">
								<small class="fw-semibold" :class="nota.TIPO_MOVIMENTO === 0 ? 'text-danger' : 'text-success'">
									{{ nota.TIPO_MOVIMENTO === 0 ? '-' : '+' }} {{ filters.formattaImporto(nota.IMPORTO) }}
								</small>
							</div>
							<div class="col-md-2 text-end">
								<small v-if="nota.FILE_ALLEGATO">
									<template v-if="isImmagine(nota.FILE_ALLEGATO)">
										<i class="ph-image me-1 text-warning"></i>
										<a href="#" @click.prevent="openImmagine(nota)" title="Visualizza immagine" class="text-warning">Immagine</a>
									</template>
									<template v-else>
										<i class="ph-paperclip me-1 text-success"></i>
										<a href="#" @click.prevent="openAllegato(nota)" title="Visualizza allegato" class="text-success">Allegato</a>
									</template>
								</small>
								<small v-else class="text-muted">nessun allegato</small>
							</div>
							<div class="col-md-2 text-end" @click.stop>
								<div class="dropdown d-inline-block">
									<a href="#" class="text-body p-0" data-bs-toggle="dropdown" aria-expanded="false">
										<i class="ph-list"></i>
									</a>
									<div class="dropdown-menu dropdown-menu-end">
										<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'modifica', notaSpesa: nota })">
											<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica
										</a>
										<div class="dropdown-divider"></div>
										<a href="#" class="dropdown-item text-danger" @click.prevent="$emit('apri-azioni', { azione: 'elimina', notaSpesa: nota })">
											<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Modal visualizzazione immagine allegato -->
	<div v-if="allegatoImgUrl" class="modal fade show" tabindex="-1" role="dialog"
	     style="display: block; background: rgba(0,0,0,0.5);"
	     @click.self="allegatoImgUrl = null">
		<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">Immagine allegato</h6>
					<button type="button" class="btn-close" @click="allegatoImgUrl = null"></button>
				</div>
				<div class="modal-body text-center p-2">
					<img :src="allegatoImgUrl" class="img-fluid" alt="Allegato" style="max-height: 70vh;" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NoteSpeseProg',
	props: {
		arrayNoteSpese: {
			type: Array,
			default: () => []
		}
	},
	emits: ['apri-azioni'],
	data() {
		return {
			collapsed: false,
			utenteCollapsed: {},
			filters: global.filters,
			allegatoImgUrl: null
		};
	},
	computed: {
		perUtente() {
			const grouped = {};

			this.arrayNoteSpese.forEach(nota => {
				const key = nota.FK_ID_UTENTE;
				if (!grouped[key]) {
					grouped[key] = {
						FK_ID_UTENTE: nota.FK_ID_UTENTE,
						nome: nota.NOME_UTENTE,
						note: [],
						totale: 0
					};
				}
				grouped[key].note.push(nota);
				grouped[key].totale += parseFloat(nota.IMPORTO);
			});

			return Object.values(grouped)
				.sort((a, b) => a.FK_ID_UTENTE - b.FK_ID_UTENTE)
				.map(u => ({
					...u,
					totale: u.totale
				}));
		},
		totalImporto() {
			const sum = this.arrayNoteSpese.reduce((sum, nota) => {
				return sum + (parseFloat(nota.IMPORTO) || 0);
			}, 0);
			return this.filters.formattaImporto(sum);
		}
	},
	methods: {
		isImmagine(filePath) {
			return /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath || '');
		},
		openImmagine(nota) {
			const baseUpload = utils.BASE_API + '../../../../thebproject/UPLOAD/';
			this.allegatoImgUrl = baseUpload + (nota.FILE_ALLEGATO || '').replace(/\\/g, '/');
		},
		openAllegato(nota) {
			utils.ajaxBlob('theb/notaspesa/allegato', { ID_NOTA_SPESA: nota.ID_NOTA_SPESA }, (blob) => {
				const url = URL.createObjectURL(blob);
				window.open(url, '_blank');
			}, true, 'POST');
		},
		toggleCollapse() {
			this.collapsed = !this.collapsed;
		},
		toggleUtente(userId) {
			this.utenteCollapsed[userId] = this.utenteCollapsed[userId] !== false ? false : true;
		}
	}
};
</script>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}

.cursor-pointer:hover {
	background-color: #f8f9fa;
}

.list-group-item {
	border-left: 3px solid transparent;
	transition: border-color 0.2s;
}

.list-group-item:hover {
	border-left-color: #007bff;
}
</style>
